angular.module('hjApp').service('ModalUpdatePurchaseOrder', [
    '$modal',
    '$q',
    'Invoice',
    'Loader',
    'Notify',
    'restDefaultHandlers',
    function ($modal, $q, Invoice, Loader, Notify, restDefaultHandlers) {
        /**
         * Show the modal for a given invoice.
         * @param {object} invoice The invoice for display/update PO Number.
         * @param {number} invoice.id The Invoice's ID.
         * @param {string} invoice.po_number The Purchase Order # on the invoice.
         * @returns {Promise} The resolved/rejected promise.
         */
        this.show = function (invoice) {
            return $modal.open({
                templateUrl: 'modal_update_purchase_order_number.html',
                controller: 'ModalUpdatePurchaseOrder',
                controllerAs: 'ctrl',
                backdrop: 'static',
                windowClass: 'modal-550 modal-update-purchase-order-number',
                resolve: {
                    invoice: _.wrap(invoice)
                }
            }).result;
        };

        /**
         * Update the purchase order number for an invoice.
         * @param {object} account The account owning the Invoice.
         * @param {number} account.id The ID of the account.
         * @param {object} invoice The invoice to update.
         * @param {number} invoice.id The ID of the invoice.
         * @param {string|null} po_number The new PO #.
         * @returns {Promise} Result.
         */
        this.updatePurchaseOrderNumber = function (account, invoice, po_number) {
            var invoiceResult = Invoice.updatePONumber(account, invoice, po_number)
                .then(function (res) {
                    invoice.po_number = res.po_number;
                    Notify.success('Purchase Order number updated.');
                    return res;
                })
                .catch(function (res) {
                    restDefaultHandlers.onError(res);
                    Notify.error('An error occurred when trying to update Purchase Order number.');
                    return $q.reject(res);
                });
            Loader.suppress(invoiceResult);
            return invoiceResult;
        };
    }
]);
